import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getPostLoginRoute } from '../constants/admin-access.constants';
import { AuthSessionService } from '../services/auth-session.service';

/**
 * For role `company`, blocks routes until `isApproved === true`.
 * Profile (`/profile`) stays reachable so the company can upload documents.
 */
@Injectable({
  providedIn: 'root',
})
export class CompanyApprovedGuard implements CanActivate {
  constructor(
    private session: AuthSessionService,
    private router: Router,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.session.ready().pipe(
      map((profile) => {
        if (!profile) {
          return true;
        }
        if (profile.role !== 'company') {
          const home = getPostLoginRoute(profile.role, profile.isApproved);
          const path = state.url.split('?')[0];
          if (path === home) {
            return true;
          }
          return this.router.createUrlTree([home]);
        }
        if (profile.isApproved === true) {
          return true;
        }
        const path = state.url.split('?')[0];
        if (
          path === '/profile' ||
          path.startsWith('/profile/') ||
          path === '/account-pending'
        ) {
          return true;
        }
        return this.router.createUrlTree(['/account-pending'], {
          queryParams: { redirect: state.url },
        });
      }),
    );
  }
}
